
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import Button from "../../shared/button/Btn"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputTextarea from "../../shared/input/new/InputTextarea"
import { FaCheck } from "react-icons/fa6";
import { copyBlockedUser, updateBlockedUsersAdmin } from "../../../features/admin3/admin3Slice"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 500px;
        max-width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            margin: 50px 30px;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center; 
            gap: 15px;
            .row{
                width: 300px;
            }
            
        }
        
        .button-grp{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 300px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
    }

    @media (max-width: 650px){
        .modal{
            width: 100% !important;
            .row{
                width: 90% !important;
            }
        }
    }
`


const AdminKaralisteTelefonEkleModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { selectedBlockedUserAdmin } = useSelector(state => state.admin3)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [phoneNumber, setPhoneNumber] = useState()

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleSubmit = () => {
        dispatch(copyBlockedUser({
            id: selectedBlockedUserAdmin.id,
            phoneNumber: phoneNumber.slice(2)
        }))
    }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
    <PageTopTitle title={"Admin Engellenen Üye"}/>
    <div className="content">
        <div className="row">
            <InputPhoneFormat data={phoneNumber} setData={setPhoneNumber} labelText={"Telefon Numarası"} inputWidth={"100%"} name={"phoneNumber"} />
        </div>
    </div>
    
    <div className='button-grp'>
        <Button handleClick={handleSubmit} bgColor="#E85446" width="150px" color="#fff">Kaydet</Button>
        <Button handleClick={() => dispatch(showModal(null))} bgColor="transparent" width="150px" color="#E85446">Kapat</Button>
    </div>
    </div>
</ModalContainer>
  )
}

export default AdminKaralisteTelefonEkleModal